import {ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot} from '@angular/router';
import {inject} from '@angular/core';
import {catchError} from 'rxjs/operators';
import {EMPTY, Observable, of} from 'rxjs';
import {ActivityApi} from '@domain/activity/activity.api';
import {ActivityDTO} from '@domain/activity/activity.dto';
import {StringUtil} from '@shared/util/string.util';


export class ActivityResolver {

  public static get: ResolveFn<ActivityDTO | null> = (route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<ActivityDTO | null> => {
    const activityId = this.resolveActivityId(route);
    if (!activityId) {
      return of(null);
    }
    const activityApi = inject(ActivityApi);
    return activityApi.getDetails(activityId).pipe(
      catchError(err => {
        if (err.status === 404) {
          // Redirect to not-found or another page
          return of(null);
        }
        // Return EMPTY to cancel current navigation
        return EMPTY;
      })
    );
  };

  public static getExpiring: ResolveFn<ActivityDTO[] | null> = (route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<ActivityDTO[] | null> => {
    const activityApi = inject(ActivityApi);
    return activityApi.getExpiring().pipe(
      catchError(err => EMPTY) // Return EMPTY to cancel current navigation
    );
  };

  public static getUnverified: ResolveFn<ActivityDTO[] | null> = (route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<ActivityDTO[] | null> => {
    const activityApi = inject(ActivityApi);
    return activityApi.getUnverified().pipe(
      catchError(err => EMPTY) // Return EMPTY to cancel current navigation
    );
  };

  public static getUntagged: ResolveFn<ActivityDTO[] | null> = (route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<ActivityDTO[] | null> => {
    const activityApi = inject(ActivityApi);
    return activityApi.getUntagged().pipe(
      catchError(err => EMPTY) // Return EMPTY to cancel current navigation
    );
  };

  public static readonly myActivities: ResolveFn<ActivityDTO[] | null> = (route: ActivatedRouteSnapshot, _state: RouterStateSnapshot) => {
    const api = inject(ActivityApi);
    return api.getAllForMe();
  };

  public static resolveActivityId(route: ActivatedRouteSnapshot): string | null {
    let activityId = route.paramMap.get('activityId');
    if (!activityId) {
      activityId = StringUtil.resolveSlug(route.paramMap.get('slug'));
    }
    return activityId ?? null;
  }

}
